const HolidayConstants = {
  weekdays: { Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6, Sunday: 0 },
};

module.exports = HolidayConstants;
